<div>
  <div class="flex justify-between items-center gap-2 mb-2 flex-wrap">
    <div class="content-projection">
      <ng-content select="[slot=groupFilter]"></ng-content>
    </div>
    <div class="legend-download-section flex items-center gap-2 justify-end ml-auto">
      <div class="border-r flex border-gray-300 legend-wrapper">
        <div class="inline-flex items-center mr-2" *ngFor="let item of legendArray">
          <span class="w-5 h-5 inline-block me-2" [ngStyle]="{ 'background-color': item.bgColor }"></span>
          <span class="text-gray-600 dark:text-gray-400">{{ item.text }}</span>
        </div>
      </div>

      <button class="mdlz-btn-outline flex items-center group" (click)="downloadExcel()">
        <i class="pi pi-download text-xl group-hover:text-white text-mdlz-primary"></i>
        <span class="ml-2 font-bold text-lg">Download</span>
      </button>

      <div class='flex justify-between items-center' *ngIf='rowGroupName !== "All"'>
        <span class='expand-collapse ml-auto' *ngIf='tableExpanded'>Collapse<img src="assets/images/collapse.svg" alt="collapse"
            (click)="toggleTreeNodeExpansion(false)" /></span>
        <span class='expand-collapse ml-auto' *ngIf='!tableExpanded'>Expand<img src="assets/images/expand.svg" alt="expand"
            (click)="toggleTreeNodeExpansion(true)" /></span>
      </div>
    </div>
  </div>

  <p-table
    #dt
    class="mdlz-expandable-table"
    [value]="filteredtableData"
    [columns]="tableHeader"
    dataKey="uid"
    [tableStyle]="{ 'min-width': '100vw' }"
    styleClass="p-datatable-gridlines p-datatable-striped"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50]"
    scrollHeight="50vh"
    [scrollable]="true"
    (onPage)="onPageChange($event)"
  >
    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th class="w-40" pFrozenColumn>
          <div *ngIf="!showFilterInput" class="flex font-bold text-left h-6">
            {{ rowGroupName }} (lbs)
            <i
              class="pi pi-search rounded-full border !border-mdlz-primary p-1.5 text-[12px] leading-none text-mdlz-primary absolute right-0 font-bold"
              (click)="showFilterInput = true"
            >
            </i>
          </div>
          <span class="p-input-icon-right w-full h-[24px]" *ngIf="showFilterInput">
            <input type="text" pInputText (focus)="$event.target['select']()" (input)="customFilter($event.target['value'])" [(ngModel)]="searchTerm" class="search-input w-full" />
            <i class="pi pi-times text-mdlz-primary text-sm" *ngIf="showFilterInput" (click)="clearFilter()"></i>
          </span>
        </th>
        <th *ngFor="let item of tableHeader" class="min-w-24">{{ item.header }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
      <tr>
        <td pFrozenColumn>
          <span [ngClass]="rowData.level == 1 ? 'ms-3' : ''" class="font-bold" [title]="rowData.node_name">
            {{ rowData.node_name.trim().length > 35 ? (rowData.node_name.trim() | slice : 0 : 32) + '...' : rowData.node_name.trim() }}
          </span>
          <span
            *ngIf="rowData.children?.length"
            pButton
            pRipple
            (click)="toggleRow(rowData)"
            class="p-button-text"
            [icon]="isRowExpanded(rowData) ? 'pi pi-minus' : 'pi pi-plus'"
          ></span>

          <!--
            rowGroupName === 'Manufacturing Network' && !rowData.children?.length -->
          <i
            *ngIf="page === 'simulation' && rowData.node_name == 'New Capacity'"
            class="fa fa-expand cursor-pointer !text-mdlz-primary m-1"
            title="View Interventions"
            (click)="openCapacityInterventionsDialog(rowData)"
          ></i>
        </td>
        <td *ngFor="let col of columns" [ngStyle]="{ 'background-color': getBackgroundColor(rowData[col.field], rowData.node_name) }">
          {{ isNumber(rowData[col.field]) ? (rowData[col.field] | formatDecimalNumber) : rowData[col.field] }}
        </td>
      </tr>

      <!-- Child Rows (Level 2) -->
      <ng-container *ngIf="isRowExpanded(rowData)">
        <ng-container *ngFor="let child of rowData.children">
          <tr>
            <td class="ps-5 indented-child" pFrozenColumn>
              <!-- Add the indented class here -->
              <span class="data-ellips" [title]="child.node_name">{{ child.node_name }}</span>
              <span
                *ngIf="child.children?.length"
                pButton
                pRipple
                (click)="toggleRow(child)"
                class="p-button-text"
                [icon]="isRowExpanded(child) ? 'pi pi-minus' : 'pi pi-plus'"
              ></span>

              <i
                *ngIf="page === 'simulation' && child.node_name == 'New Capacity'"
                class="fa fa-expand cursor-pointer !text-mdlz-primary m-1"
                title="View Interventions"
                (click)="openCapacityInterventionsDialog(child)"
              ></i>
            </td>
            <td *ngFor="let col of columns" [ngStyle]="{ 'background-color': getBackgroundColor(child[col.field], child.node_name) }">
              {{ isNumber(child[col.field]) ? (child[col.field] | formatDecimalNumber) : child[col.field] }}
            </td>
          </tr>

          <!-- Grandchild Rows (Level 3) -->
          <ng-container *ngIf="isRowExpanded(child)">
            <tr *ngFor="let grandChild of child.children">
              <td class="ps-7 indented-gchild" pFrozenColumn>
                <!-- Add the indented class here as well -->
                <span class="data-ellips" [title]="grandChild.node_name">{{ grandChild.node_name }}</span>

                <i
                  *ngIf="page === 'simulation' && grandChild.node_name == 'New Capacity'"
                  class="fa fa-expand cursor-pointer !text-mdlz-primary m-1"
                  title="View Interventions"
                  (click)="openCapacityInterventionsDialog(grandChild)"
                ></i>
              </td>
              <td *ngFor="let col of columns" [ngStyle]="{ 'background-color': getBackgroundColor(grandChild[col.field], grandChild.node_name) }">
                {{ grandChild[col.field] | formatDecimalNumber }}
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>

    <!-- Empty Message -->
    <ng-template pTemplate="emptymessage">
      <tr class="empty-data">
        No Data found.
      </tr>
    </ng-template>
  </p-table>
</div>
